import { render, staticRenderFns } from "./ProfileMenuRegionTeamMobile.vue?vue&type=template&id=1fb355d3&scoped=true"
import script from "./ProfileMenuRegionTeamMobile.vue?vue&type=script&lang=js"
export * from "./ProfileMenuRegionTeamMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb355d3",
  null
  
)

export default component.exports